module.exports = __webpack_public_path__ + "static/media/94.25304b73.png";